import FileUploadLink from './FileUploadLink';
import FileUploadButton from './FileUploadButton';
import dayjs from 'dayjs';
import * as theme from '../../theme';

export default function FileUploadContainer(props) {
  return (
    <div style={{ ...theme.Container.flexColumn, width: '100%', gap: 20 }}>
      <div style={{ ...theme.Container.flexRow, gap: 20 }}>
        <div style={{ ...theme.TruCard, width: '100%' }}>
          <div style={theme.TruCard.Header}>{props.label}</div>
          <div style={theme.TruCard.Content}>

            {props.file ? (
              <FileUploadLink 
                key={props.fileName}
                label={props.file.name || props.file.fileName}
                content={dayjs(props.file.dateUploaded ? props.file.dateUploaded.toDate() : dayjs()).format('MM/DD/YYYY h:mm A')}
                showDelete={props.showDelete}
                onClick={() => props.onClick(props.file.name || props.file.fileName)}
                onDelete={() => props.onDelete()}
              />
            ) : (
              <FileUploadButton
                key={props.fileName}
                label={'Upload ' + props.label}
                onChange={() => props.onUpload()}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}